module.exports = __webpack_public_path__ + "img/km.f07a34b.svg";